import { editUserRowsPerPage } from "../pages/Services/UserService";

const handleChangeRowsPerPage = async (tableName, pages) => {
    const rowsPerPage = JSON.parse(localStorage.getItem("rowsPerPage") || "{}");
    rowsPerPage[tableName] = pages;
    localStorage.setItem("rowsPerPage", JSON.stringify(rowsPerPage));
    const userData = JSON.parse(localStorage.getItem('userData'));
    try {
        await editUserRowsPerPage({tableName, pages: pages}, userData?.uuid);
    } catch (err) {}
}

const getRowsPerPage = (tableName) => {
    const rowsPerPage = JSON.parse(localStorage.getItem("rowsPerPage") || "{}");
    const value = rowsPerPage[tableName];
    return value !== undefined ? Number(value) : null;
}

const cleanRole = (role) => role.replace("ROLE_", "").replaceAll("_", " ");

const toSortableRoles = (data) => {
  const rolesList = Array.isArray(data) ? data : data ? [data] : [];
  return rolesList.map(cleanRole).sort().join(", ");
};

export { handleChangeRowsPerPage, getRowsPerPage, cleanRole, toSortableRoles };
